import React from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import { Row, Container } from 'react-bootstrap';


const Layout = ({ children }) => {
  return <Container fluid className='p0 middle-section'>
    <Header />
    <Container fluid className='main-container' style={{ backgroundColor: '#ffffff' }}>
      <Row>
        {children}
      </Row>
    </Container>
    <Footer />
  </Container>
};

export default Layout;